import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext'; // Import Auth Context
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebase';
// MUI Components
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
// Util imports
import { makeStyles } from '@mui/styles';
// Components
import CardInput from './cardinput';
import SubscriptionSummary from './subscriptionsummary';
// Stripe
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
    },
    summary: {
        marginRight: '20px',
        maxWidth: '300px',
    },
    box: {
        maxWidth: 500,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'flex-start',
    },
    div: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'flex-start',
        justifyContent: 'center',
    },
    button: {
        margin: '2em auto 1em',
    },
});

function Subscriptions() {
    const classes = useStyles();
    const navigate = useNavigate();
    const { currentUser, setIsSubscribed } = useAuth();
    
    // State
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');
    const [clientSecret, setClientSecret] = useState('');

    const stripe = useStripe();
    const elements = useElements();
    
    const handleSubmitPay = async (event) => {
        event.preventDefault();
    
        if (!stripe || !elements) return;
    
        try {
            const res = await axios.post('https://supremebot-image-latest.onrender.com/pay', { email });
            const clientSecret = res.data['client_secret'];
    
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: {
                        email: email,
                    },
                },
            });
    
            if (result.error) {
                console.error("Payment failed:", result.error.message);
            } else if (result.paymentIntent.status === 'succeeded') {
                console.log("💸 Payment successful!");
    
                // Optional: Update Firebase / Firestore with paid = true (via webhook or here)
    
                // ✅ Redirect to /bot
                navigate("/bot");
            }
        } catch (err) {
            console.error("Error submitting payment:", err);
        }
    };
    

    const handleSubmitSub = async (event) => {
        if (!stripe || !elements) {
            return;
        }

        if (status !== '') {
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                    billing_details: { email },
                },
            });
            if (result.error) {
                console.log(result.error.message);
            } else {
                console.log('Subscription successful!');
                handleSubscriptionSuccess();
            }
        } else {
            const result = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
                billing_details: { email },
            });

            if (result.error) {
                console.log(result.error.message);
            } else {
                const payload = { email, payment_method: result.paymentMethod.id };
                const res = await axios.post('https://supremebot-image-latest.onrender.com/sub', payload);

                const { client_secret, status } = res.data;

                if (status === 'requires_action') {
                    setStatus(status);
                    setClientSecret(client_secret);
                    stripe.confirmCardPayment(client_secret).then((result) => {
                        if (result.error) {
                            console.log(result.error.message);
                        } else {
                            console.log('Subscription successful!');
                            handleSubscriptionSuccess();
                        }
                    });
                } else {
                    console.log('Subscription successful!');
                    handleSubscriptionSuccess();
                }
            }
        }
    };

    // ✅ Function to update Firestore and redirect to /bot
    const handleSubscriptionSuccess = async () => {
        if (currentUser) {
            await updateDoc(doc(db, "users", currentUser.email), {
                subscribed: true,
            });

            setIsSubscribed(true); // Update context state
            navigate("/bot"); // Redirect to bot page
        }
    };

    return (
        <div className={classes.root}>
            <div className={classes.summary}>
                <SubscriptionSummary />
            </div>
            <Card className={classes.box}>
                <CardContent className={classes.content}>
                    <TextField
                        label="Email"
                        id="outlined-email-input"
                        helperText="Email you'll receive updates and receipts on"
                        margin="normal"
                        variant="outlined"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                    />
                    <CardInput />
                    <div className={classes.div}>
                        <Button variant="contained" color="primary" className={classes.button} onClick={handleSubmitPay}>
                            Pay
                        </Button>
                        {/* <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={handleSubmitSub}
                        >
                            Subscribe
                        </Button> */}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}

export default Subscriptions;
